import { useContext } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";

import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../authContext";
import { Button } from "react-bootstrap";

export default function NavbarAdmin({ logout }) {
  let location = useLocation();
  let navigate = useNavigate();

  const authContext = useContext(AuthContext);

  return (
    <Navbar bg="light" data-bs-theme="light" className="mb-5">
      <Container>
        <Navbar.Brand href="/">Ankiety COMS</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto"></Nav>
          <Button onClick={logout}>Wyloguj</Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
